<div id="dragDiv"
     #draggableDiv
     class="draggable resize"
     [ngStyle]="{'top.px': topPosition, 'left.px': leftPosition, 'width.px': campo.width, 'height.px': campo.height}">
      <svg #draggableIcon class="icon-draggable">
        <use #draggableUse xlink:href="#icon-draggable"></use>
      </svg>
      <svg class="icon-close" (click)="borrarCampoEditable()">
        <use xlink:href="#icon-close"></use>
      </svg>
     <div id="resizeDiv" class="pinta"></div>
</div>
